import { SubscriptionTier } from '@heidi/schema/ml-scribe';

import type { CreditUsagePopoverPlan } from '../trials-and-upgrades/credit-usage-popover/types';

const PRACTICE_TIERS: ReadonlySet<SubscriptionTier> = new Set([
  SubscriptionTier.PRO_PLUS,
  SubscriptionTier.CLINICIAN_PRO_PLUS,
]);

/**
 * Which Max plan the credit-usage surfaces talk about. Callers pass
 * `newUserTier`, which is `CLINICIAN_PRO_PLUS` for a Heidi 2 Practice seat and
 * legacy `PRO_PLUS` when the evidence-launch flows are off; both are Practice.
 */
export function resolveCreditUsagePopoverPlan(
  tier: SubscriptionTier | null | undefined,
  isClinicianPracticeTrialUser: boolean
): CreditUsagePopoverPlan {
  if ((tier != null && PRACTICE_TIERS.has(tier)) || isClinicianPracticeTrialUser) {
    return 'practiceMax';
  }
  return 'clinicianMax';
}

/** Upgrade destination tier for analytics — Clinician Max product still maps to CLINICIAN_PRO in `/products`. */
export function resolveCreditUsagePopoverTargetPlan(
  plan: CreditUsagePopoverPlan
): SubscriptionTier {
  return plan === 'practiceMax'
    ? SubscriptionTier.CLINICIAN_PRO_PLUS
    : SubscriptionTier.CLINICIAN_PRO;
}
